import { Axios } from 'src/class/Axios.js';

const mixinCreated = {
  data() {
    return {
      associations: [],
      businesses: [],
      crops: [],
      croptypes: [],
      farms: [],
      rangeDate: [],
      ribbons: [],
      years: [],
      zones: [],
    };
  },

  methods: {
    getEndPoints() {
      const axiosRequests = [];
      if (this.filterOfAssociation)
        axiosRequests.push(Axios.getMasters('businesses/associations'));
      if (this.filterOfBusinesses)
        axiosRequests.push(Axios.getMasters('businesses/normal'));
      if (this.filterOfZones) axiosRequests.push(Axios.getMasters('zones'));
      if (this.filterOfCropTypes)
        axiosRequests.push(Axios.getMasters('croptypes'));
      if (this.filterOfCrops)
        axiosRequests.push(Axios.getMasters('farms/crops'));
      if (this.filterOfFarms)
        axiosRequests.push(
          Axios.getMasters(
            `farms/farms/wt/${!this.onlyFarmsFruits ? `only` : `onlyfruit`}`
          )
        );
      axiosRequests.push(Axios.getMasters('calendars/getyearsbusiness'));

      if (this.filterOfRibbons)
        axiosRequests.push(Axios.getMasters('ribbons/only'));

      return axiosRequests;
    },

    runData(response) {
      const result = {};
      response.forEach((resp) => {
        const {
          config: { url },
          data,
        } = resp;

        switch (url) {
          case `auth/farms/farms/wt/${
            !this.onlyFarmsFruits ? `only` : `onlyfruit`
          }`:
            result.farms = data.data;
            break;

          case 'auth/calendars/getyearsbusiness':
            result.calendar = data;
            break;

          case 'auth/businesses/associations':
            result.associations = data.data;
            break;

          case 'auth/businesses/normal':
            result.businesses = data.data;
            break;

          case 'auth/zones':
            result.zones = data.data;
            break;

          case 'auth/croptypes':
            result.croptypes = data.data;
            break;

          case 'auth/farms/crops':
            result.crops = data.data;
            break;

          case 'auth/ribbons/only':
            result.ribbons = data.data;
            break;
        }
      });

      this.associations = result.associations
        ? this.concatAll(result.associations)
        : [];
      this.businesses = result.businesses ? result.businesses : [];
      this.zones = result.zones ? result.zones : [];
      this.croptypes = result.croptypes ? this.concatAll(result.croptypes) : [];
      this.crops = result.crops ? result.crops : [];
      this.farms = result.farms ? result.farms : [];
      this.ribbons = result.ribbons ? result.ribbons : [];

      if (this.filterOfTimeRange) {
        const yearsArray = Object.keys(result.calendar)
          .map((key) => [key, result.calendar[key]])
          .reverse();

        this.years = yearsArray.map((year) => {
          return { name: year[0], id: year[0], disabled: false, years: year };
        });
      }
    },
  },
};

export default mixinCreated;
